import { apiGet } from '../api.ts'
import { useQuery } from '@tanstack/react-query'
import { QueryCacheKeys } from '@/api/queryKeys.ts'
import { IAlertFalldetection } from '@/api/notification/getNotificationFalldetection.ts'

export const apiGetAlertFalldetectionDetail = async (id?: number) => {
    return await apiGet<IAlertFalldetection>(`/alert/falldetection/${id}`)
}

const useQueryGetAlertFalldetectionDetail = (id?: number) => {
    return useQuery({
        queryKey: QueryCacheKeys.notification.getAlertFalldetectionDetail(id),
        enabled: (id || -1) >= 0,
        refetchInterval: 1000,
        queryFn: async () => {
            const { data } = await apiGetAlertFalldetectionDetail(id)
            return data
        }
    })
}

export default useQueryGetAlertFalldetectionDetail

